const KEY = 'pj_first_touch'
const SENT_KEY = 'pj_attribution_sent'
const DEFAULT_URL = '/api/v2/attribution'

export interface FirstTouch {
  first_source: string
  first_medium: string
  first_campaign: string | null
}

export interface AttributionPayload {
  source: string
  medium: string
  campaign?: string
  ga_client_id?: string
}

const cookieDomain = () => (/(^|\.)payjib\.com$/.test(location.hostname) ? '; domain=.payjib.com' : '')

function getCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]+)`))
  return m ? m[1] : null
}

function setCookie(name: string, value: string) {
  document.cookie = `${name}=${value}; path=/; max-age=63072000; SameSite=Lax${cookieDomain()}`
}

export function getFirstTouch(): FirstTouch | null {
  try {
    const v = getCookie(KEY)
    return v ? JSON.parse(decodeURIComponent(v)) : null
  } catch {
    return null
  }
}

export function captureFirstTouch(defaultSource = 'direct') {
  if (getFirstTouch()) return
  const p = new URLSearchParams(location.search)
  let first_source = defaultSource
  let first_medium = 'none'
  if (p.get('utm_source')) {
    first_source = p.get('utm_source')!
    first_medium = p.get('utm_medium') || 'none'
  } else if (p.get('gclid')) {
    first_source = 'google'
    first_medium = 'cpc'
  } else if (document.referrer) {
    try {
      first_source = new URL(document.referrer).hostname.replace(/^www\./, '')
      first_medium = 'referral'
    } catch {}
  }
  const value: FirstTouch = {
    first_source,
    first_medium,
    first_campaign: p.get('utm_campaign') || null,
  }
  setCookie(KEY, encodeURIComponent(JSON.stringify(value)))
}

export function getGaClientId(): string | null {
  const m = document.cookie.match(/(?:^|; )_ga=(GA\d\.\d\.\d+\.\d+)/)
  return m ? m[1] : null
}

export function getAttributionPayload(): AttributionPayload {
  const ft = getFirstTouch()
  return {
    source: ft?.first_source || 'direct',
    medium: ft?.first_medium || 'none',
    campaign: ft?.first_campaign || undefined,
    ga_client_id: getGaClientId() || undefined,
  }
}

export async function initAttribution(url = DEFAULT_URL, token?: string | null) {
  captureFirstTouch()
  if (!token) return
  if (getCookie(SENT_KEY)) return
  for (let i = 0; i < 10 && !getGaClientId(); i++) {
    await new Promise((r) => setTimeout(r, 500))
  }
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(getAttributionPayload()),
    })
    if (res.ok) setCookie(SENT_KEY, '1')
  } catch (err) {
    console.error('Failed to send attribution:', err)
  }
}
